import { Item } from '../types/interfaces';

export async function fetchAdminItems(token: string): Promise<Item[]> {
  const res = await fetch('/api/admin/items', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to fetch items');
  return res.json();
}

export async function createAdminItem(token: string, data: Partial<Item>): Promise<Item> {
  const res = await fetch('/api/admin/items', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to create item');
  }
  return res.json();
}

export async function updateAdminItem(token: string, id: string, data: Partial<Item>): Promise<Item> {
  const res = await fetch(`/api/admin/items/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to update item');
  }
  return res.json();
}
